export default __webpack_public_path__ + "images/labeling_tutorial_1_polygon-Fakyf.gif";